/******************************************************************************
 * This file was generated by ZenStack CLI.
 ******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import { z } from 'zod';
const baseSchema = z.object({
    id: z.string(),
    providerId: z.string(),
    accountId: z.string(),
    accessToken: z.string().nullish(),
    refreshToken: z.string().nullish(),
    idToken: z.string().nullish(),
    accessTokenExpiresAt: z.coerce.date().nullish(),
    refreshTokenExpiresAt: z.coerce.date().nullish(),
    scope: z.string().nullish(),
    createdAt: z.coerce.date().default(() => new Date()),
    updatedAt: z.coerce.date(),
}
).strict();
const baseSchemaWithoutDefaults = z.object({
    id: z.string(),
    providerId: z.string(),
    accountId: z.string(),
    accessToken: z.string().nullish(),
    refreshToken: z.string().nullish(),
    idToken: z.string().nullish(),
    accessTokenExpiresAt: z.coerce.date().nullish(),
    refreshTokenExpiresAt: z.coerce.date().nullish(),
    scope: z.string().nullish(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
}
).strict();
const relationSchema = z.object({
    user: z.record(z.string(), z.unknown()),
}
);
const fkSchema = z.object({
    userId: z.string(),
}
);

/**
 * `Account` schema excluding foreign keys and relations.
 */
export const AccountScalarSchema = baseSchema;


/**
 * `Account` schema including all fields (scalar, foreign key, and relations) and validations.
 */
export const AccountSchema = AccountScalarSchema.merge(fkSchema).merge(relationSchema.partial());


/**
 * Schema used for validating Prisma create input. For internal use only.
 * @private
 */
export const AccountPrismaCreateSchema = baseSchemaWithoutDefaults.partial().passthrough();


/**
 * Schema used for validating Prisma update input. For internal use only.
 * @private
 */
export const AccountPrismaUpdateSchema = z.object({
    id: z.string(),
    providerId: z.string(),
    accountId: z.string(),
    accessToken: z.string().nullish(),
    refreshToken: z.string().nullish(),
    idToken: z.string().nullish(),
    accessTokenExpiresAt: z.coerce.date().nullish(),
    refreshTokenExpiresAt: z.coerce.date().nullish(),
    scope: z.string().nullish(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date()
}).partial().passthrough();


/**
 * `Account` schema for create operations excluding foreign keys and relations.
 */
export const AccountCreateScalarSchema = baseSchemaWithoutDefaults.partial({
    id: true, createdAt: true, updatedAt: true
});


/**
 * `Account` schema for create operations including scalar fields, foreign key fields, and validations.
 */
export const AccountCreateSchema = AccountCreateScalarSchema.merge(fkSchema);


/**
 * `Account` schema for update operations excluding foreign keys and relations.
 */
export const AccountUpdateScalarSchema = baseSchemaWithoutDefaults.partial();


/**
 * `Account` schema for update operations including scalar fields, foreign key fields, and validations.
 */
export const AccountUpdateSchema = AccountUpdateScalarSchema.merge(fkSchema.partial());

